"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadController = void 0;
const wait_1 = require("../wait");
class DownloadController {
    paused = false;
    promise;
    async waitWhilePaused() {
        await (0, wait_1.waitForCondition)(() => !this.paused);
    }
    pause() {
        this.paused = true;
    }
    resume() {
        this.paused = false;
    }
    async completion() {
        await this.promise;
    }
}
exports.DownloadController = DownloadController;
//# sourceMappingURL=controller.js.map